import { NextPage } from 'next'
import ProductScreen from '../screens/Product'
import AppProductScreen from '../screens/App-Product'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const Product: NextPage = () => {
    const { showDesktopUI } = ScreenWidthPort()

    return (
        <>
            {showDesktopUI ? (<ProductScreen />) : (<AppProductScreen />)}
        </>
    )
}
